'use client';

// TODO: replace by QGDS icon and move it to functional
export const Edit = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 18 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M15.41 1.79988L14.2 0.589883C13.42 -0.190117 12.15 -0.190117 11.37 0.589883L8.69 3.26988L0 11.9599V15.9999H4.04L12.78 7.25988L15.41 4.62988C16.2 3.84988 16.2 2.57988 15.41 1.79988ZM3.21 13.9999H2V12.7899L10.66 4.12988L11.87 5.33988L3.21 13.9999ZM8 15.9999L12 11.9999H18V15.9999H8Z"
				fill="currentColor"
			/>
		</svg>
	);
};
